import { IComponentOptions } from "angular";
import {
  RoleDetailUserEditComponentController,
  vsControllerAs,
} from "./controller";

export const vsComponentName = "roleDetailUsersEditComponent";

export const roleDetailUserEditComponentOptions: IComponentOptions = {
  controller: RoleDetailUserEditComponentController,
  controllerAs: vsControllerAs,
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    role: "<",
    roleUsers: "<",
  },
};
